import React, { Component } from "react";
import { FooterLogo } from "../../store/types/appEssentials";
import Image from "../Image"

export default class Footer extends Component {
  render() {
    return (
      <div
        style={{
          position: "fixed",
          width: "100%",
          bottom: 0,
          color: "#043b72",
          backgroundColor: "white",
          zIndex: 99999,
          fontSize: 13,
          padding: "5px 0px",
          textAlign: "center",
          boxShadow: "0px 0px 3px 0px lightgray",
          
        }}
      >  <div>
        <div style={{ marginLeft: 10, marginRight: 10 }}>
          Mutual Fund investments are subject to market risks, read all scheme
          related documents carefully.
        </div>{" "}
        <div>© 2023, Bajaj Asset Management All rights reserved.</div>
        </div>
        <div style={{position: "absolute" , bottom : "8px" ,right : "10px"}}>
         <Image
                src={FooterLogo}
                alt="logo_image"
                style={{padding:"10px" , width: "320px" }}
              />
        </div>
      </div>
    );
  }
}
